/**
 * sw-sp-slidemenu18.js
 */

"use strict";
(function ($, win, doc) {
  let $doc, $win, swns;
  $win = $(win);
  $doc = $(doc);



  $(() => {


    $("#slidemenu > span.button").on("click", function (e) {
      e.preventDefault();
      $(this).parent().removeClass("init");
      $("#slidemenu").addClass("active");
      $(this).addClass("opened");
      $("span.buttonOpen").addClass("open");
      $("#overLay").addClass("open");

      $(".slidemenu").addClass("on");

    });

    $("span.buttonOpen, #overLay").on("click", function (e) {
      e.preventDefault();
      $(this).parent().addClass("init");
      $("#slidemenu").removeClass("active");
      $("span.button").removeClass("opened");
      $(this).removeClass("open");
      $("#overLay").removeClass("open");

      $(".slidemenu").removeClass("on");
    });

  });

})(jQuery, window, document);
